'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

var _lodash = require('lodash');

var _elementUtil = require('../elementUtil');

var _EdgeDragHandle = require('./EdgeDragHandle');

var _EdgeDragHandle2 = _interopRequireDefault(_EdgeDragHandle);

var _ConnectedEdgeDragHandle = require('./ConnectedEdgeDragHandle');

var _ConnectedEdgeDragHandle2 = _interopRequireDefault(_ConnectedEdgeDragHandle);

var _ControlPointDragHandle = require('./ControlPointDragHandle');

var _ControlPointDragHandle2 = _interopRequireDefault(_ControlPointDragHandle);

var _ConnectedControlPointDragHandle = require('./ConnectedControlPointDragHandle');

var _ConnectedControlPointDragHandle2 = _interopRequireDefault(_ConnectedControlPointDragHandle);

var _LineSvg = require('./svg/LineSvg');

var _LineSvg2 = _interopRequireDefault(_LineSvg);

var _ElementUserTag = require('../../user/userActivity/ElementUserTag');

var _ElementUserTag2 = _interopRequireDefault(_ElementUserTag);

var _lineConstants = require('../../../common/lines/lineConstants');

require('./Line.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Lib


// Utils


// Components


// Constant


// Styles


var Line = function (_React$Component) {
    _inherits(Line, _React$Component);

    function Line() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, Line);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Line.__proto__ || Object.getPrototypeOf(Line)).call.apply(_ref, [this].concat(args))), _this), _this.checkHitArea = function (event) {
            var target = event.target;

            // TODO this.line && this.hitArea aren't doing anything at the moment
            // If the hit area is clicked then don't prevent or stop anything - allow the propagation to continue
            // onto the draggable element which will handle the dragging

            if (target === _this.hitArea || target === _this.line || target === _reactDom2.default.findDOMNode(_this.startDragHandle) || target === _reactDom2.default.findDOMNode(_this.endDragHandle) || target === _reactDom2.default.findDOMNode(_this.controlPointData)) return;

            event.preventDefault();
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(Line, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.props.disableDrag && this.props.disableDrag();
        }

        /**
         * Used to prevent dragging from occurring when clicking the space surrounding the arrow.
         */

    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _props = this.props,
                elementId = _props.elementId,
                elementEvents = _props.elementEvents,
                isSelected = _props.isSelected,
                colorHex = _props.colorHex,
                isPresentational = _props.isPresentational,
                start = _props.start,
                end = _props.end,
                updateLineEdge = _props.updateLineEdge,
                gridSize = _props.gridSize,
                toggleLineVisibility = _props.toggleLineVisibility,
                startStyle = _props.startStyle,
                endStyle = _props.endStyle,
                isRemotelySelected = _props.isRemotelySelected,
                updateLineControlPoint = _props.updateLineControlPoint,
                controlPoint = _props.controlPoint,
                enableDrag = _props.enableDrag,
                disableDrag = _props.disableDrag,
                startConnectionRect = _props.startConnectionRect,
                endConnectionRect = _props.endConnectionRect,
                element = _props.element,
                startSnapped = _props.startSnapped,
                endSnapped = _props.endSnapped,
                startEdgeOrigin = _props.startEdgeOrigin,
                endEdgeOrigin = _props.endEdgeOrigin,
                dragModifierKeys = _props.dragModifierKeys;


            if ((0, _lodash.isEmpty)(start) || (0, _lodash.isEmpty)(end)) return null;

            var classes = (0, _elementUtil.elementClassNames)('Line', this.props);

            var color = isRemotelySelected ? null : colorHex;

            return _react2.default.createElement(
                'div',
                { id: (0, _elementUtil.getDomElementId)(elementId), className: classes, onMouseDown: this.checkHitArea },
                _react2.default.createElement(_ElementUserTag2.default, _extends({}, this.props, { top: controlPoint.y, left: controlPoint.x })),
                _react2.default.createElement(_EdgeDragHandle2.default, { pos: start, show: isSelected, snapped: startSnapped }),
                _react2.default.createElement(_EdgeDragHandle2.default, { pos: end, show: isSelected, snapped: endSnapped }),
                _react2.default.createElement(_ControlPointDragHandle2.default, { pos: controlPoint, color: color, show: isSelected }),
                _react2.default.createElement(_LineSvg2.default, { elementId: elementId, elementEvents: elementEvents, start: start, end: end,
                    controlPoint: controlPoint, isPresentational: isPresentational,
                    startStyle: startStyle, endStyle: endStyle, gridSize: gridSize,
                    colorHex: color, idSuffix: isPresentational ? 'drag' : null,
                    disableDrag: disableDrag, enableDrag: enableDrag }),
                _react2.default.createElement(_ConnectedEdgeDragHandle2.default, { edge: _lineConstants.LINE_EDGE.start, pos: start, show: isSelected && !isPresentational,
                    updateLineEdge: updateLineEdge, gridSize: gridSize, toggleLineVisibility: toggleLineVisibility,
                    dragModifierKeys: dragModifierKeys,
                    element: element, origin: endEdgeOrigin, elementId: elementId,
                    ref: function ref(component) {
                        _this2.startDragHandle = component;
                    } }),
                _react2.default.createElement(_ConnectedEdgeDragHandle2.default, { edge: _lineConstants.LINE_EDGE.end, pos: end, show: isSelected && !isPresentational,
                    updateLineEdge: updateLineEdge, gridSize: gridSize, toggleLineVisibility: toggleLineVisibility,
                    dragModifierKeys: dragModifierKeys,
                    element: element, origin: startEdgeOrigin, elementId: elementId,
                    ref: function ref(component) {
                        _this2.endDragHandle = component;
                    } }),
                _react2.default.createElement(_ConnectedControlPointDragHandle2.default, { controlPoint: controlPoint,
                    startEdgeOrigin: startEdgeOrigin, endEdgeOrigin: endEdgeOrigin, color: color,
                    toggleLineVisibility: toggleLineVisibility, gridSize: gridSize, element: element,
                    updateLineControlPoint: updateLineControlPoint, elementId: elementId,
                    ref: function ref(component) {
                        _this2.controlPointData = component;
                    },
                    startConnectionRect: startConnectionRect, endConnectionRect: endConnectionRect,
                    show: isSelected && !isPresentational })
            );
        }
    }]);

    return Line;
}(_react2.default.Component);

Line.propTypes = {
    element: _propTypes2.default.object,
    elementId: _propTypes2.default.string.isRequired,
    elementEvents: _propTypes2.default.object,
    isSelected: _propTypes2.default.bool,
    isPresentational: _propTypes2.default.bool,
    colorHex: _propTypes2.default.string,
    start: _propTypes2.default.object,
    end: _propTypes2.default.object,
    updateLineEdge: _propTypes2.default.func,
    updateLineControlPoint: _propTypes2.default.func,
    toggleLineVisibility: _propTypes2.default.func,
    gridSize: _propTypes2.default.number,
    startStyle: _propTypes2.default.string,
    endStyle: _propTypes2.default.string,
    isRemotelySelected: _propTypes2.default.bool,
    startSnapped: _propTypes2.default.bool,
    endSnapped: _propTypes2.default.bool,
    startEdgeOrigin: _propTypes2.default.object,
    endEdgeOrigin: _propTypes2.default.object,
    controlPoint: _propTypes2.default.object,
    enableDrag: _propTypes2.default.func,
    disableDrag: _propTypes2.default.func,
    startConnectionRect: _propTypes2.default.object,
    endConnectionRect: _propTypes2.default.object,
    dragModifierKeys: _propTypes2.default.object
};

exports.default = Line;


//////////////////
// WEBPACK FOOTER
// ./src/client/element/line/Line.js
// module id = 303
// module chunks = 0